<template>
  <div class="ui-slick-carousel">
    <VueSlickCarousel
      :key="slickKey"
      ref="slickCarousel"
      class="item-carousel"
      :arrows="true"
      :dots="false"
      :fade="true"
      :adaptive-height="true"
      :initial-slide="initialSlide"
      v-bind="settings"
      @beforeChange="setCurrentSlide"
    >
      <span
        v-for="(item, i) in imageCollection"
        :key="item.src"
      >
        <picture>
          <source
            :srcset="`${item.preview}.webp`"
            type="image/webp"
          >
          <source
            :srcset="item.preview"
            type="image/jpeg"
          >
          <img
            :ref="`imageCarousel`+i"
            class="slick-slide__item"
            :src="item.preview"
            :style="imageStyle"
            alt="Карточка ПВЗ"
            @error="(e) => {errorLoad(e, i)}"
          >
        </picture>
      </span>
    </VueSlickCarousel>

    <ul
      v-if="imageCollection.length > 1"
      data-v-3d1a4f76=""
      class="slick-dots"
      style="display: block;"
    >
      <li
        v-for="(item, i) in imageCollection"
        :key="item.src"
        :class="{'slick-active': i === currentSlide}"
        @click="() => {slickGoTo(i)}"
      >
        <button>{{ i }}</button>
      </li>
    </ul>
    <div
      v-if="enableModalFull"
      class="slick-gallery__btn-full-window"
      @click="openModalFullGallery"
    />
    <ModalFullGallery
      v-if="showModalFullGallery"
      :odp="odp"
      :current-slide="currentSlide"
      @close="showModalFullGallery = false"
    />
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import ModalFullGallery from './ModalFullGallery.vue';

export default {
  name: 'SlickGallery',
  components: {
    VueSlickCarousel,
    ModalFullGallery,
  },
  props: {
    odp: Object,
    enableModalFull: {
      type: Boolean,
      default: true,
    },
    initialSlide: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      slickKey: 1,
      imageCollection: this.odp.photos.length ? this.odp.photos : [],
      currentSlide: 0,
      windowWidth: null,
      width: 600,
      height: 400,
      settings: {
        arrows: false,
        dots: false,
        fade: true,
        adaptiveHeight: true,
        speed: 0,
      },
      showModalFullGallery: false,
    };
  },
  computed: {
    imageStyle() {
      const heightValue = 'height:auto';

      if (this.$refs[`imageCarousel${this.currentSlide}`]) {
        const image = this.$refs[`imageCarousel${this.currentSlide}`];
        if (image.naturalWidth < image.naturalHeight) {
          return 'position: relative; transform: translateY(-25%);';
        }
        return `width: 100%; ${heightValue}`;
      }
      return `width: 100%; ${heightValue}`;
    },
  },
  watch: {
    odp: {
      handler(newVal, oldVal) {
        if (!newVal) return;
        // При изменении модели будем вставлять новые фото
        this.imageCollection = newVal.photos;
        if (oldVal.photos.length < 2) {
          this.slickKey += 1;
        } else {
          // Откатимся на первый слайд
          this.$refs.slickCarousel.goTo(0);
          this.currentSlide = 0;
        }
      },
      deep: true,
    },
  },
  beforeMount() {
    this.currentSlide = this.initialSlide;
  },
  mounted() {
    this.windowWidth = window.innerWidth;
  },
  methods: {
    errorLoad(e, i) {
      // При ошибке загрузке фотографии, изменим коллекцию.
      this.imageCollection.splice(i, 1);
    },
    slickGoTo(i) {
      this.$refs.slickCarousel.goTo(i);
    },
    setCurrentSlide(oldSlide, newSlide) {
      // подпишемся на изменения слайдов
      this.currentSlide = newSlide;
    },
    openModalFullGallery() {
      this.showModalFullGallery = true;
    },
  },
};
</script>

<style lang="scss">
  @import "SlickGallery.scss";
</style>
